import { GameProgressData } from "@lib/titan2-slingo/dist/api/model/data/GameProgressData";
/**
 * ExtendedGameProgressData.ts
 */
export class ExtendedGameProgressData extends GameProgressData {
    solidify() {
        super.solidify();
    }
}
//# sourceMappingURL=ExtendedGameProgressData.js.map